import script from "./HospitalEnvironment.vue?vue&type=script&setup=true&lang=js"
export * from "./HospitalEnvironment.vue?vue&type=script&setup=true&lang=js"

import "./HospitalEnvironment.vue?vue&type=style&index=0&id=7bd30e42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bd30e42"]])

export default __exports__